import env from "../constants/env";

export const toApiUrl = (path: string): string => {
    const joinWith = path[0] === '/' ? '' : '/';
    return `${env.apiUrl}${joinWith}${path}`
};
